angular.module('picmonicng').directive('tag', [
  function () {
    return {
      restrict: 'E',
      transclude: true,
      template: '<div class="tag" ng-transclude></div>',
    };
  },
]);
